// extracted by mini-css-extract-plugin
export var pagination = "pagination-module--pagination--5TBQ0";
export var paginationContainer = "pagination-module--paginationContainer--IC+IW";
export var paginationItem = "pagination-module--paginationItem--7j9GU";
export var paginationItemActive = "pagination-module--paginationItemActive--NzjI4";
export var paginationColumnLeft = "pagination-module--paginationColumnLeft--r9ohU";
export var paginationColumnCenter = "pagination-module--paginationColumnCenter--AEjM4";
export var paginationColumnRight = "pagination-module--paginationColumnRight--ee+21";